import { render, staticRenderFns } from "./voluntaryPf.vue?vue&type=template&id=0869eb49&scoped=true"
import script from "./voluntaryPf.vue?vue&type=script&lang=js"
export * from "./voluntaryPf.vue?vue&type=script&lang=js"
import style0 from "./voluntaryPf.vue?vue&type=style&index=0&id=0869eb49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0869eb49",
  null
  
)

export default component.exports